import React from 'react';
import classnames from 'classnames';
import Popover from 'components/pure/utils/Popover';
import './RuleNotificationToggle.styl';
export default class RuleNotificationToggle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showTooltip: false,
    };
  }

  render() {
    const {rule} = this.props;
    return (
      <div className="rule-notification-toggle">
        <span
          className={classnames('notification-dot', !!rule.rulePermissions.NOTIFY && 'active')}
          onClick={() => this.props.toggleNotify(rule, !!rule.rulePermissions.NOTIFY)}
          ref={c => (this.parent = c)}
          onMouseEnter={() => this.setState({showTooltip: true})}
          onMouseLeave={() => this.setState({showTooltip: false})}>
          <Popover
            className="destyle-popover"
            canAutoPosition={false}
            open={this.state.showTooltip}
            useLayerForClickAway={false}
            anchorEl={this.parent}
            anchorOrigin={{
              horizontal: 'middle',
              vertical: 'top',
            }}
            targetOrigin={{
              horizontal: 'middle',
              vertical: 'bottom',
            }}>
            <div className={classnames('tooltip-container', 'tail')}>
              <div className="ev-tooltip">
                <div className="tooltip-content">
                  <div>
                    This notification is turned {rule.rulePermissions.NOTIFY ? 'ON' : 'OFF'}.
                  </div>
                  <div>Click to turn it {rule.rulePermissions.NOTIFY ? 'OFF' : 'ON'}.</div>
                </div>
              </div>
            </div>
          </Popover>
        </span>
      </div>
    );
  }
}
